import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import EztMsp from "../pages/products/ezt-map/page";
import EnterpriseInsightPage from "../pages/products/enterprise-insight/page";
import BusinessAnalyticsPage from "../pages/products/business-analytics/page";
import GovGridPage from "../pages/products/gov-grid/page";
import UpgradePage from "../pages/upgrade/page";
import ApiServicePage from "../pages/api-service/page";
import PersonalSpacePage from "../pages/personal-space/page";
import MobilePage from "../pages/mobile/page";
import ApiPingTaiPage from "../pages/api-pingtai/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/products/ezt-map", element: <EztMsp /> },
  { path: "/products/enterprise-insight", element: <EnterpriseInsightPage /> },
  { path: "/products/business-analytics", element: <BusinessAnalyticsPage /> },
  { path: "/products/gov-grid", element: <GovGridPage /> },
  { path: "/upgrade", element: <UpgradePage /> },
  { path: "/api-service", element: <ApiServicePage /> },
  { path: "/personal-space", element: <PersonalSpacePage /> },
  { path: "/mobile", element: <MobilePage /> },
  { path: "/api-pingtai", element: <ApiPingTaiPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
